import { useEffect, useRef, useState } from "react";
import { UserID, EulaValue, Features, Role, Companyid, MasterId } from "../User";
import loader from "../img/sample.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faFile, faFilePdf, faCloudArrowUp, faCheck, faShield, faShieldAlt, faStar, faList, faSmileBeam, faUserTie, faCheckSquare, faLightbulb, faClose, faXmark, faSearch, faDeleteLeft, faRemove } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import $ from 'jquery';
import Cookies from "js-cookie";
import grammarlypdf from "../pdf/grammarly.pdf"
import copyscapepdf from "../pdf/copyscape.pdf"
import shieldicon from "../img/shieldicon.png"
import { v4 as uuidv4, NIL as NIL_UUID } from "uuid";
import heic2any from "heic2any";
import { n2d } from "n2d";
import moment from 'moment';
import { GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import {
    duplicateresultcontent,
    duplicateresultparacontenttemplate,
    ChatGPTemailcontent,
    truidraggable,
} from "../email/templateBase";
import copy from 'copy-to-clipboard';
import { ReactSearchAutocomplete } from "react-search-autocomplete";

import ContentLoader from "react-content-loader";

export const getAccessToken = () => Cookies.get('userInfo');

const MyLoader = () => (    
  <ContentLoader 
  speed={1}
  width={200}
  height={100}
  viewBox="0 0 200 100"
  backgroundColor="#808080"
  foregroundColor="#ecebeb"
  style={{ width: '100%' }}
>
  <rect x="48" y="8" rx="3" ry="3" width="88" height="6" /> 
  <rect x="48" y="26" rx="3" ry="3" width="52" height="6" /> 
  <rect x="0" y="56" rx="3" ry="3" width="410" height="6" /> 
  <rect x="0" y="72" rx="3" ry="3" width="380" height="6" /> 
  <rect x="0" y="88" rx="3" ry="3" width="178" height="6" /> 
  <circle cx="20" cy="20" r="20" />
</ContentLoader>
  );

const Mls = () => {

    var t = 0;
    const [query, setQuery] = useState("");
    const [upload_div_visibility, setupload_div_visibility] = useState(true)
    const autoCompleteRef = useRef(null);
    const [locationId, setLocationId] = useState("");
    const [generatedcontent, setgeneratedcontent] = useState("");
    const [copySacpeAvailable, setDataprop] = useState(false);
    const [grammarlyKeyData, setgrammarlyKeyData] = useState("");
    const [plagiarismmodalbody, setplagiarismmodalbody] = useState({ __html: '' });
    const [uploadedfile, setuploadedfile] = useState([]);
    const [processedimage, setprocessedimage] = useState([]);
    const [orderedprocessedimage, setorderedprocessedimage] = useState([]);
    const [dropdownvalues, setdropdownvalues] = useState([]);
    const [videocreatedformdata, setvideocreatedformdata] = useState({});
    const [uploadedimages, setuploadedimages] = useState([]);
    const [processid, setprocessid] = useState("");
    const [analyzingroomtype, setanalyzingroomtype] = useState(null);
    const [imagecaption, setimagecaption] = useState([]);
    const [roomtypes, setroomtypes] = useState([]);
    const [compliancepassed, setcompliancepassed] = useState(null);
    const [listingdescriptionstatus, setlistingdescriptionstatus] = useState(-1);
    const localimagebasepath = `${process.env.REACT_APP_API_URL}` + "/Uploads/MLSCOMPLIANCE/";
    const historygoback = () => {
        window.history.back();
    }
    let autoComplete;
    let createnewcontent = false;
    const loadScript = (url, callback) => {
        let script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = () => callback();
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };
    function clearPropAddress() {
        document.getElementById('txtPropAddress').value = "";
        // document.getElementById("div1Result").style.display="none";    
    }

    const componentDidMount = () => {
        // load initial data
        // onTabClick(1);
        document.addEventListener('copy', function (e) {
            const text_only = document.getSelection().toString();
            const clipdata = e.clipboardData || window.clipboardData;
            clipdata.setData('text/plain', text_only);
            e.preventDefault();
        });
    };

    function checkcopyscape() {
        const axios = require('axios');
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}` + '/api/ArtificialIntelligence/Getcopyscapeavailable?userid=' + (Role == 3 ? MasterId : UserID)
        };

        axios.request(config)
            .then((response) => {
                if (response.data != null && response.data.Data != "") {
                    var resd = response.data.Data;
                    setDataprop(resd);
                }
            })
            .catch((error) => {
                console.log(error);
                setDataprop(false);
            });
    }

    useEffect(() => {
        componentDidMount();
        loadScript(
            `https://maps.googleapis.com/maps/api/js?key=AIzaSyDxpx25xmwMAYNW3Diz0TjL3N8CtTURTK0&libraries=places`,
            () => handleScriptLoad(setQuery, autoCompleteRef, setLocationId)
        );
        // checkcopyscape();
        var localgrammarlyKeyData = (Cookies.get('g_key') != undefined ? Cookies.get('g_key') : '');
        setgrammarlyKeyData(localgrammarlyKeyData);
    }, []);

    useEffect(() => {
        if (analyzingroomtype == false) {
            setTimeout(() => {
                processcompliance(processid);
            }, 1000);
        }
    }, [analyzingroomtype]);

    useEffect(() => {
        if (compliancepassed) {
            checkcopyscape();
        }
    }, [compliancepassed])

    function handleScriptLoad(updateQuery, autoCompleteRef, updateLocation) {
        autoComplete = new window.google.maps.places.Autocomplete(
            autoCompleteRef.current,
            { types: ["address"], componentRestrictions: { country: "us" } }
        );
        autoComplete.setFields(["address_components", "formatted_address", "place_id", "geometry"]);
        autoComplete.addListener("place_changed", () =>
            handlePlaceSelect(updateQuery, updateLocation)
        );
    }

    async function handlePlaceSelect(updateQuery, UpdateLocation) {
        const addressObject = autoComplete.getPlace();
        const query = addressObject.formatted_address;
        updateQuery(query);
        console.log(addressObject);
        const latitude = addressObject.geometry.location.lat();
        const longitude = addressObject.geometry.location.lng()
        console.log(latitude + "," + longitude);
        UpdateLocation(latitude + "," + longitude);
        document.getElementById("hfLocationId").value = latitude + "," + longitude;
        // onAddressSelection(latitude,longitude);
        // debugger;
        // getBKIPropertyInfo(query);
    }

    function onAddressSelection(funlat, funlng) {
        //alert('inside address selection');
        var locationIdValue = document.getElementById("hfLocationId").value
        //console.log('address location id '+ locationIdValue);    
        // showoverlay();
        // setTimeout(() => {
        //     loadAmenities(funlat,funlng);    
        // }, 3000);

    }

    function getBKIPropertyInfo(addressProp) {
        debugger;
        addressProp = encodeURI(addressProp);
        const axios = require('axios');
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}` + '/api/AIUserManager/GetBKIPropertyInfo?UserId=userid&PropertyAddress=' + addressProp
        };

        axios.request(config)
            .then((response) => {
                if (response.data != null && response.data.Status == "200" && response.data.Data != null && response.data.Data != "") {
                    var resd = response.data.Data;
                    console.log("Property found");
                    try {
                        // bind data
                        //     "Basement": null,
                        // "Baths": null, -- ddlBathrooms -- DONE
                        // "Bedrooms": "0", // ddlBedrooms -- DONE
                        // "Fireplace": null, // txtGLR -- DONE
                        // "FullBaths": "0",
                        // "GarageNumCars": "2", // ddlGaragespaces -- DONE
                        // "LotSize": "2", txtArea
                        // "PartialBaths": "0",
                        // "Pool": null, DONE -- DONE
                        // "PropertyType" : "Residential",  -- ddlPropertyType or UseCodeDescription  -- DONE
                        // "Stories": "1 Story", // ddlFloors --
                        // "YearBuilt": "1997" // 

                        if (resd.Baths != null && resd.Baths != undefined && resd.Baths != "") {
                            var tBaths = parseInt(resd.Baths);
                            if (tBaths > 0 && tBaths < 11) {
                                document.getElementById("ddlBathrooms").value = tBaths;
                            }
                        }
                        if (resd.Bedrooms != null && resd.Bedrooms != undefined && resd.Bedrooms != "") {
                            var tbeds = parseInt(resd.Bedrooms);
                            if (tbeds > 0 && tbeds < 11) {
                                document.getElementById("ddlBedrooms").value = tbeds;
                            }
                        }
                        if (resd.GarageNumCars != null && resd.GarageNumCars != undefined && resd.GarageNumCars != "") {
                            var tGarageNumCars = parseInt(resd.GarageNumCars);
                            if (tGarageNumCars > 0 && tGarageNumCars < 11) {
                                document.getElementById("ddlGaragespaces").value = tGarageNumCars;
                            }
                        }
                        if (resd.PropertyType != null && resd.PropertyType != undefined && resd.PropertyType != "") {
                            //// "PropertyType" : "Residential",  -- ddlPropertyType or UseCodeDescription
                            var mainPropTypeValue = "singlefamily";
                            var propSubType = "";
                            if (resd.UseCodeDescription != null && resd.UseCodeDescription != undefined && resd.UseCodeDescription != "") {
                                propSubType = resd.UseCodeDescription;
                                if (propSubType.includes("single") || propSubType.includes("Single")) {
                                    mainPropTypeValue = "singlefamily";
                                }
                                else if (propSubType.includes("multi") || propSubType.includes("Multi")) {
                                    mainPropTypeValue = "multifamily";
                                }
                                else if (propSubType.includes("condo") || propSubType.includes("Condo")) {
                                    mainPropTypeValue = "condo";
                                }
                                else if (propSubType.includes("villa") || propSubType.includes("Villa")) {
                                    mainPropTypeValue = "villa";
                                }
                                else if (propSubType.includes("town") || propSubType.includes("Town")) {
                                    mainPropTypeValue = "townhouse";
                                }
                                else if (propSubType.includes("apartment") || propSubType.includes("Apartment")) {
                                    mainPropTypeValue = "apartment";
                                }
                                else if (propSubType.includes("resident") || propSubType.includes("Resident") || propSubType.includes("Resi")) {
                                    mainPropTypeValue = "residential";
                                }
                                else if (propSubType.includes("land") || propSubType.includes("Land")) {
                                    mainPropTypeValue = "land";
                                }
                                else if (propSubType.includes("commercial") || propSubType.includes("Commercial") || propSubType.includes("Comm")) {
                                    mainPropTypeValue = "commercial";
                                }
                                //commercial
                            } else {
                                propSubType = resd.PropertyType;
                                if (propSubType.includes("resident") || propSubType.includes("Resident") || propSubType.includes("Resi")) {
                                    mainPropTypeValue = "residential";
                                }
                                else if (propSubType.includes("land") || propSubType.includes("Land")) {
                                    mainPropTypeValue = "land";
                                }
                                else if (propSubType.includes("commercial") || propSubType.includes("Comm") || propSubType.includes("Commercial")) {
                                    mainPropTypeValue = "commercial";
                                }
                            }
                            document.getElementById("ddlPropertyType").value = mainPropTypeValue;
                        } // end of property type
                        if (resd.Fireplace != null && resd.Fireplace != undefined && resd.Fireplace != "") {
                            document.getElementById("txtMostSalable").value = "FirePlace " + resd.Fireplace;
                        }
                        if (resd.Pool != null && resd.Pool != undefined && resd.Pool != "") {
                            var txtGLR = document.getElementById("txtMostSalable");
                            if (txtGLR.value != "") {
                                txtGLR.value = ", Pool " + resd.Pool;
                            } else {
                                txtGLR.value = "Pool " + resd.Pool;
                            }
                        }
                        if (resd.LotSize != null && resd.LotSize != undefined && resd.LotSize != "") {
                            var tLotSize = parseFloat(resd.LotSize);
                            if (tLotSize > 0) {
                                document.getElementById("txtArea").value = tLotSize.toString();
                            }
                        }
                        if (resd.Stories != null && resd.Stories != undefined && resd.Stories != "") {
                            var tStories = resd.Stories;
                            var stories = 0;
                            if (tStories.includes("1")) {
                                stories = 1;
                            }
                            else if (tStories.includes("2")) {
                                stories = 2;
                            }
                            else if (tStories.includes("3")) {
                                stories = 3;
                            }
                            else if (tStories.includes("4")) {
                                stories = 4;
                            }
                            else if (tStories.includes("5")) {
                                stories = 5;
                            }

                            if (tStories > 0 && tStories < 6) {
                                document.getElementById("ddlFloors").value = stories;
                            }
                        }
                    } catch (error) {
                        console.log("error in Property binding");
                    }
                }
            })
            .catch((error) => {
                console.log("Property not found");
            });
    }

    function copyToClipboard() {
        copy(document.getElementById('divGeneratedContent').innerText, { format: "text/plain" });
        customAlertMessage('success', 'Copied!');
    };

    function copyToClipboardEdit() {
        if (document.getElementById('hrefEditContent').innerText == "Update") {
            document.getElementById('divGeneratedContent').contentEditable = "false";
            document.getElementById('hrefEditContent').innerText = "Edit";
        }
        else {
            document.getElementById('divGeneratedContent').contentEditable = "true";
            document.getElementById('hrefEditContent').innerText = "Update";
        }
    }
    const checkCountersLimit = () => {
        var userI = getAccessToken();
        var decodedUser1 = decodeURIComponent(userI);
        var parsedRes1 = JSON.parse(decodedUser1);
        var PlanType = parsedRes1.PlanType;
        if (PlanType < 1) { // free trial
            const axios = require('axios');
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}` + '/api/AIUserManager/GetUserCounters?UserId=' + (Role == 3 ? MasterId : UserID) + '&CounterType=UsedPropertyDescription',
                headers: {}
            };

            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    if (response.data != undefined) {
                        if ((response.data.Data != "" || response.data.Data == 0) && response.data.Status == "200") {
                            var availblecounter = response.data.Data;
                            if (availblecounter <= 0) {
                                document.getElementById('psubtext').innerText = 'You trial resources have been exhausted. Please upgrade to a paid subscription.';
                                document.getElementById('hrefsubscription').click();
                                return;
                            }
                            else {
                                generateaicontentCounters();
                                // movetoordering();
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            // end of free trial
        } else {
            generateaicontentCounters();
            //movetoordering();
        }
    }
    const generateaicontent = () => {
        createnewcontent = true;
        showoverlayprop();
        setTimeout(() => {
            checkCountersLimit();
        }, 3000);
    }
    function customAlertMessage(icon, message) {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: false,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: icon,//'success',
            title: message// 'Signed in successfully'
        })
    }

    const dropzonechange = (e) => {
        try {
            var tempfilesarr = e.target.files;// $(".dropzone")[0].files;
            if (tempfilesarr.length <= 0) {
                return;
            }
            // showoverlaytwo();
            var tempfileaftervalidation = [];
            var uploadedfilearray = [];// uploadedfile;
            var containsiphonefiles = false;
            var invalidfilecount = 0;
            for (let i = 0; i < tempfilesarr.length; i++) {
                const element = tempfilesarr[i];
                var validfile = (element.type === 'image/jpg' || element.type === 'image/jpeg' || element.type === "image/png")
                if (!validfile && element.name.split('.').pop() != "heif" && element.name.split('.').pop() != "heic") {
                    customAlertMessage('error', 'File type not supported files removed.');
                    invalidfilecount += 1;
                    continue;
                }
                if (element.size < 10485760) {
                    var uploadedfile_json = {};
                    var tempfileaftervalidation_json = {};
                    if (element.name.split('.').pop() != 'heif' && element.name.split('.').pop() != 'heic') {
                        // var alreadyuploadedfile = uploadedfile.filter(function (entry) { return entry.binaryfile == element; });
                        // if (alreadyuploadedfile.length > 0) {
                        //     continue;
                        // }
                        var uniqueid = uuidv4();
                        uploadedfile_json.identity = uniqueid;
                        uploadedfile_json.binaryfile = element;
                        uploadedfilearray.push(uploadedfile_json);

                        tempfileaftervalidation_json.identity = uniqueid;
                        tempfileaftervalidation_json.binaryfile = element;
                        tempfileaftervalidation.push(tempfileaftervalidation_json);
                        console.log('file added: ' + element.name);
                    }
                    else {
                        containsiphonefiles = true
                    }
                }
                else {
                    customAlertMessage('error', 'Maximum file size exceeded images removed.');
                    invalidfilecount += 1;
                }
            }
            if (containsiphonefiles) {
                for (let i = 0; i < tempfilesarr.length; i++) {
                    const element = tempfilesarr[i];
                    if (element.name.split('.').pop() == "heif" || element.name.split('.').pop() == "heic") {
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            // showoverlaytwo();
                            fetch(e.target.result)
                                .then((res) => res.blob())
                                .then((blob) => heic2any({ blob, toType: "image/jpeg", quality: 0.1 }))
                                .then((conversionResult) => {
                                    // conversionResult is a BLOB
                                    // of the PNG formatted image
                                    var url = URL.createObjectURL(conversionResult);
                                    var file = new File([conversionResult], uuidv4() + ".jpg");
                                    // var alreadyuploadedfile = uploadedfile.filter(function (entry) { return entry.binaryfile == element; });
                                    // if (alreadyuploadedfile.length <= 0) {
                                    //     continue;
                                    // }
                                    var uploadedfile_json = {};
                                    var tempfileaftervalidation_json = {};
                                    var uniqueid = uuidv4();
                                    uploadedfile_json.identity = uniqueid;
                                    uploadedfile_json.binaryfile = file;
                                    uploadedfilearray.push(uploadedfile_json);

                                    tempfileaftervalidation_json.identity = uniqueid;
                                    tempfileaftervalidation_json.binaryfile = file;
                                    tempfileaftervalidation.push(tempfileaftervalidation_json);
                                    console.log('file added iphone: ' + file.name);
                                    console.log('files added : ' + tempfileaftervalidation.length);
                                    if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                        console.log('fired to load inside iphone')
                                        setTimeout(() => {
                                            readFile(tempfileaftervalidation);
                                            setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
                                        }, 2000);
                                    }
                                })
                                .catch((e) => {
                                    // see error handling section
                                    //customAlertMessage('error','Error occured while processing an image, please try again.'); 
                                    // hideoverlaytwo();
                                    invalidfilecount += 1;
                                    if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                        readFile(tempfileaftervalidation);
                                        setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
                                    }
                                });
                        }
                        reader.readAsDataURL(element);
                    }
                }
            }
            else {
                readFile(tempfileaftervalidation);
                setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
                console.log('fired to load outside iphone')
            }
        } catch (error) {
            console.log(error);
            hideoverlaytwo();
        }

    };
    const dropzonedragenter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.dropzone-wrapper').addClass('dragover');
    }
    const dropzonedragover = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.dropzone-wrapper').addClass('dragover');
    };
    const dropzonedragleave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.dropzone-wrapper').removeClass('dragover');
    };
    const dropzonefiledrop = (event) => {
        event.preventDefault();
        var tempfilesarr = event.dataTransfer.files;
        var tempfileaftervalidation = [];
        var uploadedfilearray = [];// uploadedfile;
        var containsiphonefiles = false;
        var invalidfilecount = 0;
        for (let i = 0; i < tempfilesarr.length; i++) {
            const element = tempfilesarr[i];
            var validfile = (element.type === 'image/jpg' || element.type === 'image/jpeg' || element.type === "image/png")
            if (!validfile && element.name.split('.').pop() != "heif" && element.name.split('.').pop() != "heic") {
                customAlertMessage('error', 'File type not supported files removed.');
                invalidfilecount += 1;
                continue;
            }
            if (element.size < 10485760) {
                var uploadedfile_json = {};
                var tempfileaftervalidation_json = {};
                if (element.name.split('.').pop() != 'heif' && element.name.split('.').pop() != 'heic') {
                    var uniqueid = uuidv4();
                    uploadedfile_json.identity = uniqueid;
                    uploadedfile_json.binaryfile = element;
                    uploadedfilearray.push(uploadedfile_json);

                    tempfileaftervalidation_json.identity = uniqueid;
                    tempfileaftervalidation_json.binaryfile = element;
                    tempfileaftervalidation.push(tempfileaftervalidation_json);
                }
                else {
                    containsiphonefiles = true
                }
            }
            else {
                customAlertMessage('error', 'Maximum file size exceeded images removed.');
                invalidfilecount += 1;
            }
        }
        if (containsiphonefiles) {
            for (let i = 0; i < tempfilesarr.length; i++) {
                const element = tempfilesarr[i];
                if (element.name.split('.').pop() == "heif" || element.name.split('.').pop() == "heic") {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        // showoverlaytwo();
                        fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => heic2any({ blob, toType: "image/jpeg", quality: 0.1 }))
                            .then((conversionResult) => {
                                // conversionResult is a BLOB
                                // of the PNG formatted image
                                var url = URL.createObjectURL(conversionResult);
                                var file = new File([conversionResult], uuidv4() + ".jpg");
                                var uploadedfile_json = {};
                                var tempfileaftervalidation_json = {};
                                var uniqueid = uuidv4();
                                uploadedfile_json.identity = uniqueid;
                                uploadedfile_json.binaryfile = file;
                                uploadedfilearray.push(uploadedfile_json);

                                tempfileaftervalidation_json.identity = uniqueid;
                                tempfileaftervalidation_json.binaryfile = file;
                                tempfileaftervalidation.push(tempfileaftervalidation_json);
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    readFileondrop(tempfileaftervalidation);
                                    setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
                                }
                            })
                            .catch((e) => {
                                // see error handling section
                                //customAlertMessage('error','Error occured while processing an image, please try again.'); 
                                // hideoverlaytwo();
                                invalidfilecount += 1;
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    readFile(tempfileaftervalidation);
                                    setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
                                }
                            });

                    }
                    reader.readAsDataURL(element);
                }
            }
        }
        else {
            readFileondrop(tempfileaftervalidation);
            setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
        }
        // $(".dropzone")[0].value = "";
    };

    const readFileondrop = (inputfiles) => {
        var singletimearray = []; // processedimage;
        var propertyorderedlist = [];// [...orderedprocessedimage];
        for (let i = 0; i < inputfiles.length; i++) {
            const element = inputfiles[i].binaryfile;
            var reader = new FileReader();
            reader.onload = function (e) {
                var uniqimg = {};
                var timingidentity = moment().valueOf();
                uniqimg.refid = inputfiles[i].identity;
                uniqimg.id = timingidentity;
                uniqimg.image = e.target.result;
                singletimearray.push(uniqimg);
                if (orderedprocessedimage.length > 0) {
                    var selem = {};
                    selem.orderid = orderedprocessedimage.length + (i + 1);
                    selem.id = timingidentity;
                    selem.refid = inputfiles[i].identity;
                    selem.image = e.target.result;
                    selem.binaryfile = element;
                    propertyorderedlist.push(selem);
                }
                if (i == (inputfiles.length - 1)) {
                    var processedimagenew = singletimearray.sort(function (a, b) { return a.id - b.id; });
                    setprocessedimage(processedimage => [...processedimage, ...processedimagenew]);
                    setorderedprocessedimage(orderedprocessedimag => [...orderedprocessedimag, ...propertyorderedlist]);
                    // hideoverlaytwo();
                    // showoverlaytwo();
                    // setTimeout(() => {
                    //     loaddropdownfromstate();
                    // }, 2000);
                }

            };
            reader.readAsDataURL(element);
        }
    }
    const showoverlaytwo = () => {
        document.getElementById("overlaytwo").style.display = "block";
        $("body").addClass("loader");
    };
    const hideoverlaytwo = () => {
        document.getElementById("overlaytwo").style.display = "none";
        $("body").removeClass("loader");
    };
    const showoverlay = () => {
        document.getElementById("overlay").style.display = "block";
        $("body").addClass("loader");
    };
    const hideoverlay = () => {
        document.getElementById("overlay").style.display = "none";
        $("body").removeClass("loader");
    };
    // const loaddropdownfromstate = () => {
    //     if (dropdownvalues.length > 0) {
    //         var selectddl = document.getElementsByClassName('imageoption');
    //         for (let i = 0; i < selectddl.length; i++) {
    //             const element = selectddl[i];
    //             var refid = element.dataset.filerefid;
    //             var selectedoption = dropdownvalues.filter(function (entry) { return entry.refid == refid; });
    //             if (selectedoption.length > 0) {
    //                 element.value = selectedoption[0].text;
    //             }
    //         }
    //         hideoverlaytwo();
    //     }
    //     else {
    //         hideoverlaytwo();
    //     }
    // }
    const readFile = (inputfiles) => {
        // var input = $('.dropzone')[0];
        // var inputfiles = input.files;
        var singletimearray = [];// [...processedimage];
        var propertyorderedlist = [];// [...orderedprocessedimage];
        console.log('inputfiles.length', inputfiles.length);
        for (let i = 0; i < inputfiles.length; i++) {
            const element = inputfiles[i].binaryfile;
            console.log('reading inputfiles : ', element.name);
            var reader = new FileReader();
            reader.onload = function (e) {
                var uniqimg = {};
                var timingidentity = moment().valueOf();
                uniqimg.refid = inputfiles[i].identity;
                uniqimg.id = timingidentity;
                uniqimg.image = e.target.result;
                singletimearray.push(uniqimg);
                if (orderedprocessedimage.length > 0) {
                    var selem = {};
                    selem.orderid = orderedprocessedimage.length + (i + 1);
                    selem.id = timingidentity;
                    selem.refid = inputfiles[i].identity;
                    selem.image = e.target.result;
                    selem.binaryfile = element;
                    propertyorderedlist.push(selem);
                }
                if (i == (inputfiles.length - 1)) {
                    var processedimagenew = singletimearray.sort(function (a, b) { return a.id - b.id; });
                    setprocessedimage(processedimage => [...processedimage, ...processedimagenew]);
                    setorderedprocessedimage(orderedprocessedimag => [...orderedprocessedimag, ...propertyorderedlist]);
                    // hideoverlaytwo();
                    // showoverlaytwo();
                    // setTimeout(() => {
                    //     loaddropdownfromstate();
                    // }, 2000);
                }
            };
            reader.readAsDataURL(element);
        }
    }
    const uploadimages = () => {
        // setupload_div_visibility(false);
        if (uploadedfile.length > 0) {
            uploadimagestoserver();
            document.getElementById('upload_div').style.display = "none";
            document.getElementById('main_div').style.display = "flex";
        }
        else {
            customAlertMessage('error', 'Please select files and proceed.');
        }

    }
    const uploadimagestoserver = () => {
        const axios = require('axios');
        const FormData = require('form-data');
        // const fs = require('fs');
        showoverlaytwo();
        let data = new FormData();
        data.append('uid', '3a2ab8ee-5264-4a8a-895b-bbcbb96882e0');
        data.append('companyid', '15');
        if (uploadedfile.length > 0) {
            for (let i = 0; i < uploadedfile.length; i++) {
                const element = uploadedfile[i].binaryfile;
                data.append('files', element);
            }
        }
        else {
            customAlertMessage('error', 'Please select files and proceed');
            document.getElementById('upload_div').style.display = "block";
            document.getElementById('main_div').style.display = "none";
            return;
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}` + '/api/ArtificialIntelligence/uploadmlscomplianceimages',
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                var Responsedata = response.data.Data;
                if (Responsedata != "" && Responsedata != null) {
                    var tempuploadedimages = Responsedata.imagelist;
                    setuploadedimages(upimage => [...upimage, ...tempuploadedimages])
                    setprocessid(Responsedata.processid);
                    hideoverlaytwo();
                    setTimeout(() => {
                        processroomtypes(Responsedata.processid);
                    }, 1000);
                }
                else {
                    customAlertMessage('error', 'Something went wrong, Please try again.');
                    document.getElementById('upload_div').style.display = "block";
                    document.getElementById('main_div').style.display = "none";
                    hideoverlaytwo();
                }

            })
            .catch((error) => {
                console.log(error);
                customAlertMessage('error', 'Something went wrong, Please try again.');
                document.getElementById('upload_div').style.display = "block";
                document.getElementById('main_div').style.display = "none";
                hideoverlaytwo();
            });

    }
    const processroomtypes = (processidparam) => {
        const axios = require('axios');
        const FormData = require('form-data');
        showoverlay();
        setanalyzingroomtype(true);
        let data = new FormData();
        data.append('processid', (processid == "" ? processidparam : processid));
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}` + '/api/ArtificialIntelligence/imagecaption',
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                var DATA = response.data.Data;
                var resultroomtypes = [];
                if (DATA != null && DATA != "") {
                    var results = DATA;
                    setimagecaption(results);
                    results.forEach(element => {
                        var lielement = document.getElementById(element.imagename.split('.').join('_'));
                        lielement.getElementsByTagName('h4')[0].innerText = (element.roomtype);
                        lielement.getElementsByTagName('p')[0].innerText = (element.description);
                        var roomjson = {};
                        var existroomtypes = resultroomtypes.filter(x => x.name == element.roomtype);
                        if (existroomtypes != undefined && existroomtypes.length > 0) {
                            existroomtypes[0].count += 1;
                        }
                        else {
                            roomjson.name = element.roomtype;
                            roomjson.count = 1;
                            resultroomtypes.push(roomjson);
                        }
                    });

                    setroomtypes(room => [...room, ...resultroomtypes]);
                    setanalyzingroomtype(false);

                }
                else {
                    customAlertMessage('error', 'Something went wrong, Please try again.');
                    setanalyzingroomtype(null);
                }
                hideoverlay();
            })
            .catch((error) => {
                customAlertMessage('error', 'Something went wrong, Please try again.');
                console.log(error);
                setanalyzingroomtype(null);
                hideoverlay();
            });

    }
    const processcompliance = (processidparam) => {
        const axios = require('axios');
        const FormData = require('form-data');
        showoverlaypropcomp();
        // setcompliancepassed(false);
        let data = new FormData();
        data.append('processid', (processid == "" ? processidparam : processid));
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}` + '/api/ArtificialIntelligence/imagecompliance',
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                var DATA = response.data.Data;
                var resultroomtypes = [];
                if (DATA != null && DATA != "") {
                    var compliancepassed = DATA.compliancepassed;
                    setcompliancepassed(compliancepassed);
                    if (compliancepassed == false) {

                    }
                    var results = DATA.list;
                    // setimagecaption(results);
                    // results.forEach(element => {
                    //     var lielement = document.getElementById(element.imagename.split('.').join('_'));
                    //     lielement.getElementsByTagName('h4')[0].innerText = (element.roomtype);
                    //     lielement.getElementsByTagName('p')[0].innerText = (element.description);
                    //     var roomjson = {};
                    //     var existroomtypes = resultroomtypes.filter(x=> x.name == element.roomtype);
                    //     if (existroomtypes != undefined && existroomtypes.length > 0) {
                    //         existroomtypes[0].count += 1;
                    //     }
                    //     else{
                    //         roomjson.name = element.roomtype;
                    //         roomjson.count = 1;
                    //         resultroomtypes.push(roomjson);
                    //     }                
                    // });

                    // setroomtypes(room => [...room,...resultroomtypes]);

                }
                else {
                    customAlertMessage('error', 'Something went wrong, Please try again.');
                }
                // setanalyzingroomtype(false);
                updateProgressBartoend()
                setTimeout(() => {
                    hideoverlaypropcomp();
                }, 2000);

            })
            .catch((error) => {
                customAlertMessage('error', 'Something went wrong, Please try again.');
                console.log(error);
                updateProgressBartoend();
                hideoverlaypropcomp();
            });

    }
    function showoverlaypropcomp() {
        document.getElementById('compliancecheck').style.display = "flex";
        document.getElementById('imagesdiv').style.display = "none";
        $('body').addClass("loader");
        updateProgressBar(uploadedimages.length);
    }
    function hideoverlaypropcomp() {
        document.getElementById('compliancecheck').style.display = "none";
        document.getElementById('imagesdiv').style.display = "block";
        $('body').removeClass("loader");
    }

    function updateProgressBartoend() {
        var progressbar = document.querySelectorAll('.progress-bar');
        progressbar.forEach(element => {
            const progressBarElement = element;
            progressBarElement.style.width = '100%';
        });
    }

    function updateProgressBar(numberOfImages) {
        // Assuming each image takes an average of 4 seconds to load
        const averageTimePerImage = 10000; // in milliseconds
        const totalTime = numberOfImages * averageTimePerImage;
        var progressbar = document.querySelectorAll('.progress-bar');
        progressbar.forEach(element => {
            // const progressBarElement = element;
            updateSingleProgressBar(element, numberOfImages)
            // let currentTime = 0;
            // // Interval to update the progress bar every 100 milliseconds
            // const interval = setInterval(function () {
            //     // Calculate the percentage of the total time that has passed
            //     const percentage = (currentTime / totalTime) * 100;
            //     progressBarElement.style.width = percentage + '%';

            //     // Increment the current time
            //     currentTime += 100;

            //     // If the total time has passed, clear the interval
            //     if (currentTime >= totalTime) {
            //         clearInterval(interval);
            //         progressBarElement.style.width = '100%'; // Ensure the bar is fully filled
            //     }
            // }, 100);
        });
    }

    function updateSingleProgressBar(progressBarElement, numberOfImages) {
        // Assuming each image takes an average of 4 seconds to load
        const averageTimePerImage = 10000; // in milliseconds
        const totalTime = numberOfImages * averageTimePerImage;
        let currentTime = 0;

        // Interval to update the progress bar every 100 milliseconds
        const interval = setInterval(function () {
            // Calculate the percentage of the total time that has passed
            const percentage = (currentTime / totalTime) * 100;
            progressBarElement.style.width = percentage + '%';
            progressBarElement.innerText = Math.round(percentage) + '%';

            // Increment the current time
            currentTime += 100;

            // If the total time has passed, clear the interval
            if (currentTime >= totalTime) {
                clearInterval(interval);
                progressBarElement.style.width = '100%'; // Ensure the bar is fully filled
                // progressBarElement.innerText = '100%';
            }
        }, 100);
    }

    function showoverlayprop() {
        document.getElementById('newloaderprop').style.display = "flex";
        document.getElementById('main_div').style.display = "none";
        $('body').addClass("loader");
    }
    function hideoverlayprop() {
        document.getElementById('newloaderprop').style.display = "none";
        document.getElementById('main_div').style.display = "flex";
        $('body').removeClass("loader");
    }

    const generateaicontentCounters = () => {
        document.getElementById("divGeneratedContent").innerHTML = "description start";
        try {
            document.getElementById("plagiarisminfo").style.display = "none";
        } catch (error) {

        }
        document.getElementById("divGeneratedContent").innerHTML = "";
        // document.getElementById("h4Title").innerHTML="";
        document.getElementById("spanCharCount").style.display = "none";
        document.getElementById("divOutputIcons").style.display = "none";
        showoverlayprop();
        setlistingdescriptionstatus(0);
        var prompt = "";
        var txtPropAddress = document.getElementById('txtPropAddress').value;
        prompt = "Generate detailed property listing description for " + txtPropAddress + ". ";
        prompt += getroomtypebreakdown() + ". The property special features were "
        prompt += getroomfeatures();
        prompt += ". Also include headline note on header and call to action at the end of the description.";
        prompt += " Make description paragraph wise."

        console.log(prompt);
        var lengthcontroller = "2000";//this.getselectedcontentlength();
        var Supplement = "";//this.gettexteleValue("textareaoutput", "Supplement");
        var toneofvoice = "";//this.gettexteleValue("toneofvoice", "Tone");
        var keywords = "";//this.gettexteleValue("keywordinput", "Keyword");
        var prompttext = ("Topic: " + prompt);
        var axios = require("axios");

        const FormData = require('form-data');
        var tokens = 4000;
        let data = new FormData();
        data.append('prompt', prompttext.trim());
        data.append('uid', (Role == 3 ? MasterId : UserID));
        data.append('cid', Companyid);
        data.append('token', tokens);

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}` + '/api/ArtificialIntelligence/GetGroqResponse',
            data: data
        };

        axios(config)
            .then(function (resp) {
                var response = resp.data;
                if (resp != null && response != "" && response.Data != "") {
                    var datalist = response.Data.split('\n');
                    var finalData = "";
                    for (var i = 0; i < datalist.length; i++) {
                        if (datalist[i] != "") {
                            finalData = finalData + datalist[i] + "\n";
                        }
                    }
                    //   hideoverlay();      
                    //   //window.scrollTop = document.body.scrollHeight;
                    $("html, body").animate({ scrollTop: document.body.scrollHeight }, "slow");
                    t = 0;
                    finalData = finalData.replace("Headline: ", "").replace("Headline:", "").replace("headline: ", "").replace("Paragraph 1:", "").replace("Paragraph 2:", "").replace("Paragraph 3:", "").replace("Paragraph 4:", "").replace("Paragraph 5:", "").replace("Paragraph 6:", "");
                    finalData = finalData.replace("Call to Action: ", "").replace("Headline note:", "").replace("Headline Note:", "");
                    var divOuterContent = document.getElementById('divOuterContent');
                    divOuterContent.scrollTop = divOuterContent.scrollHeight;
                    typeWriter(finalData);
                    document.getElementById('divGeneratedContent').contentEditable = "true";
                    document.getElementById("spanCharCount").style.display = "block";
                }
                hideoverlayprop();
                setlistingdescriptionstatus(1);
            })

            .catch(function (error) {
                console.log(error);
                hideoverlayprop();
                setlistingdescriptionstatus(2);
                //document.getElementById("newloaderprop").style.display="none";
                customAlertMessage(
                    "error",
                    "Something went wrong, please try again."
                );
            });
    }
    const typeWriter = (datalist, Dataobjects) => {
        var speed = 10;
        if (t < datalist.length) {
            var textLst = datalist.charAt(t);
            document.getElementById("divGeneratedContent").innerHTML += textLst === "\n" ? "<p></p>" : textLst;
            t++;
            document.getElementById("lblCcount").innerHTML = t;
            setTimeout(function () { typeWriter(datalist, Dataobjects) }, speed);
            //window.scrollTo(0, document.body.scrollHeight);
            var elementsDiv1 = document.getElementById("divGeneratedContent");
            elementsDiv1.scrollTop = elementsDiv1.scrollHeight;
        }
        if (t + 1 == datalist.length) {
            console.log('inside final');
            document.getElementById("divOutputIcons").style.display = "block";
            // Highlightkeys(Dataobjects);

        }
    }
    function showoverlay4() {
        document.getElementById('overlayloader4').style.display = "block";
        $('body').addClass("loader");
    }
    function hideoverlay4() {
        document.getElementById('overlayloader4').style.display = "none";
        $('body').removeClass("loader");
    }
    function Checkplagiarism() {
        try {
            if (document.getElementById("divGeneratedContent").innerText == "") {
                this.customAlertMessage(
                    "warning",
                    "cannot check plagiarism for empty content."
                );
                return;
            }
        } catch (error) {
            this.customAlertMessage("error", "Error occured, Please try again.");
            return;
        }

        showoverlay4();

        var axios = require("axios");
        var FormData = require("form-data");
        var data = new FormData();
        data.append(
            "postdata",
            document.getElementById("divGeneratedContent").innerText.trim()
        );
        data.append("uid", (Role == 3 ? MasterId : UserID));
        data.append("companyid", Companyid);

        var config = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}` + "/api/ArtificialIntelligence/checkduplicatebyformdata",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (resp) {
                var response = resp.data;
                if (response.Data != null) {
                    if (response.Data.count != null && response.Data.count === 0) {
                        customAlertMessage("success", "No plagiarism found");
                        document.getElementById("plagiarisminfo").style.display = "none";
                        // document.getElementById("plagiarismmodalbody").innerHTML = "";
                        setplagiarismmodalbody({ __html: '' });
                        // $(elem).find('.checkmark').show();
                        // $(elem).find('.ban').hide();
                        // $(elem).attr('tooltip', "No plagiarism found.");
                        // $(elem).attr('onclick', "return false;");
                    } else if (response.Message == "small content") {
                        customAlertMessage("info", response.Data);
                    } else {
                        document.getElementById("plagiarisminfo").innerText =
                            response.Data.count + " copies found";
                        document.getElementById("plagiarisminfo").style.display =
                            "inline-block";
                        var htmlnew = duplicateresultcontent;
                        htmlnew = htmlnew.replace("[PHCScount]", response.Data.count);
                        htmlnew = htmlnew.replace(
                            "[PHCSquerywords]",
                            response.Data.querywords
                        );
                        var duplicateresultparagraphlist = "";
                        for (var i = 0; i < response.Data.count; i++) {
                            var result = response.Data.result[i];
                            var duplicateresultparacontent =
                                duplicateresultparacontenttemplate;
                            duplicateresultparacontent = duplicateresultparacontent.replace(
                                "[PHCSurl]",
                                result.url
                            );
                            duplicateresultparacontent = duplicateresultparacontent.replace(
                                "[PHCSurltext]",
                                result.url
                            );
                            duplicateresultparacontent = duplicateresultparacontent.replace(
                                "[PHCStitle]",
                                result.title
                            );
                            duplicateresultparacontent = duplicateresultparacontent.replace(
                                "[PHCShtmlsnippet]",
                                result.textsnippet
                            );
                            duplicateresultparagraphlist =
                                duplicateresultparagraphlist + duplicateresultparacontent;
                        }
                        htmlnew = htmlnew.replace(
                            "[PHCSparagraphlist]",
                            duplicateresultparagraphlist
                        );
                        // document.getElementById("plagiarismmodalbody").innerHTML = htmlnew;
                        setplagiarismmodalbody({ __html: htmlnew });
                        customAlertMessage("error", "Plagiarism found");
                    }
                } else {
                    customAlertMessage("error", "Error occured, Please try again."); // 'success','failure','info'
                }
                hideoverlay4();
            })
            .catch(function (error) {
                //console.log(error);
                customAlertMessage("error", "Something went wrong, Try Again.");
                hideoverlay4();
            });
    };

    const generatecontentfromdescription = () => {
        document.getElementById('imagesdiv').style.display = 'none';
        document.getElementById('editordiv').style.display = 'block';
        var txtPropAddress = document.getElementById('txtPropAddress').value;
        if (txtPropAddress.trim() === "") {
            customAlertMessage('error', 'Please enter property address.');
            return;
        }
        generateaicontentCounters();
    }

    const getroomtypebreakdown = () => {
        var photobreakli = document.querySelectorAll('.photobreak li');
        var roomtypetext = "";
        photobreakli.forEach((element, idx, array) => {
            var photobreaklispan = element.getElementsByTagName('span');
            if (photobreaklispan.length > 0) {
                roomtypetext += "It has a " + photobreaklispan[1].innerText + " " + photobreaklispan[0].innerText + ", ";
                if (idx !== array.length - 1) {
                    roomtypetext += ", ";
                }
            }
        });
        return roomtypetext;
    }

    const getroomfeatures = () => {
        var photobreakli = document.querySelectorAll('.mlsright li');
        var roomfeaturestext = "";
        photobreakli.forEach((element, idx, array) => {
            var photobreaklipara = element.getElementsByTagName('p');
            if (photobreaklipara.length > 0) {
                roomfeaturestext += photobreaklipara[0].innerText;
                if (idx !== array.length - 1) {
                    roomfeaturestext += ", ";
                }
            }
        });
        return roomfeaturestext;
    }

    const comingsoon = () => {
        customAlertMessage('info', 'We are working on it, Coming Soon.');
    }
    // const removerequiredfield = (e) => {
    //     var vallll = e.currentTarget.value;
    //     var element = e.currentTarget;
    //     var tempdropdownvalues = dropdownvalues;
    //     if (vallll != "-1") {
    //         element.classList.remove("requirederror");
    //     }
    //     else {
    //         element.classList.add("requirederror");
    //     }
    //     var refid = element.dataset.filerefid;
    //     var selectedoption = tempdropdownvalues.filter(function (entry) { return entry.refid == refid; });
    //     if (selectedoption.length > 0) {
    //         selectedoption[0].text = vallll;
    //     }
    //     else {
    //         var sitem = {};
    //         sitem.refid = refid;
    //         sitem.text = vallll;
    //         tempdropdownvalues.push(sitem);
    //     }
    //     setdropdownvalues(tempdropdownvalues);
    // }

    // render(){
    //htmlhere
    return (
        <div className="main_content_iner overly_inner dashboard-page">
            <div className="container-fluid p-0 ">
                <div className="row">
                    <div className="col-12">
                        <div className="title-card1">
                            <h4>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={historygoback}
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                    MLS
                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="row" id="newloaderprop" style={{ display: "none" }}>
                    <div className="col-12">
                        <div className="rotating-text-wrapper-new">
                            <center></center><img src={loader} className="loadernewprop" />
                            <div class="rotating-text-wrapper">
                                {/* <h2>Checking images for branding.</h2>
                                <h2>Checking images for sign posts.</h2>
                                <h2>Checking images for watermarks.</h2>
                                <h2>Checking images for agent info...</h2>
                                <h2>Checking images for people...</h2>
                                <h2>Checking images for custom MLS rules...</h2> */}
                                <h2>Hold tight, chocolatechips.ai is writing the description for you!</h2>
                                <h2>Adding a powerful headline....</h2>
                                <h2>Almost done....</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" id="upload_div">
                    <div className="col-12" style={{marginBottom:"20px"}}>
                        <div className="row">
                            <div className="col-12" id="divpropertyaddress">
                                <div className="row">
                                    <div className="col-9" style={{ position: "relative" }}>                                        
                                        <label>
                                            Property address
                                        </label>
                                        {/* <input type="text" className="common-input"></input> */}
                                        {/* <SearchLocationInput onChange={() => null} /> */}
                                        <div className="search-location-input">
                                            <input id="txtPropAddress"
                                                ref={autoCompleteRef} className="common-input"
                                                onChange={event => setQuery(event.target.value)}
                                                placeholder="Enter your address"
                                                value={query}
                                            />
                                            <FontAwesomeIcon className="clearProp" onClick={() => clearPropAddress()} icon={faXmark} />
                                            <input id="hfLocationId" value={locationId} type="hidden"></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="dropzone-wrapper mobiletop0" style={{ width: "100%", marginBottom: "40px", marginTop: "15px" }} onDragEnter={dropzonedragenter} onDragOver={dropzonedragover} onDragLeave={dropzonedragleave} onDrop={dropzonefiledrop} >
                            <div id="overlayiphone">
                                <div id="loading" style={{ top: "35%" }}>
                                    <img src={loader} />
                                    <h2 id="loaderheading" className="loaderheading"><span>Processing...</span></h2>
                                </div>
                            </div>
                            <div className="dropzone-desc">
                                <h4>Drag and Drop</h4>
                                <p><b>or Click to upload</b></p>
                                <FontAwesomeIcon icon={faCloudArrowUp} />
                                <p>
                                    Supported Files: PNG, JPG, HEIF, HEIC.
                                </p>
                                {uploadedfile && uploadedfile.length > 0 ?
                                    <p>
                                        {uploadedfile.length} images selected.
                                    </p>
                                    : null}
                            </div>
                            <input type="file" name="img_logo" className="dropzone" title='' onChange={dropzonechange} accept="image/png, image/jpeg, image/jpg, image/heif, image/heic" multiple={true}></input>
                        </div>
                    </div>
                    <div className="col-12">
                    <ul className="mlsuploadedphoto">
                            <li>
                                <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                            <li>
                                <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                <span className="removeuploaded">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className="col-12">
                            <center>
                                <a href="javascript:;" className="common-save" style={{ marginTop: "20px", marginBottom:"30px" }} onClick={uploadimages}>Continue</a>
                            </center>
                        </div>
                    {processedimage && processedimage.length > 0 ?
                        <div className="col-12">
                            <center>
                                <a href="javascript:;" className="common-save" style={{ marginTop: "20px", marginBottom:"30px" }} onClick={uploadimages}>Continue</a>
                            </center>
                        </div> : null}
                </div>
                <div className="row" id="main_div">
                    <div className="col-12" style={{ position: 'relative' }}>
                        <div id="overlayloader4" className="email-overlay" style={{ display: "none" }}>
                            <div id="loading">
                                <img src={loader} />
                                {/* <h2 id="loaderheading" className="loaderheading">...</h2> */}
                            </div>
                        </div>
                        <div id="overlaytwo">
                            <div id="loading" style={{ top: "30%" }}>
                                <img src={loader} />
                                <h2 id="loaderheading" className="loaderheading"><span>Processing...</span></h2>
                            </div>
                        </div>
                        <div id="overlay">
                            <div id="loading" style={{ top: "30%" }}>
                                <img src={loader} />
                                <h2 id="loaderheading" className="loaderheading"><span>Analyzing room types...</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-2 mlsleftside">
                        <label>
                            <h4>Photo Upload</h4>
                            {uploadedimages.length > 0 ?
                                <p>Ok! ({uploadedimages.length} images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                :
                                <p className="loadingellipsis">Processing</p>
                            }
                        </label>
                        <label>
                            <h4>Photo/Room Types</h4>
                            {uploadedimages.length > 0 && analyzingroomtype != null && analyzingroomtype == false ?
                                <p>Ok! ({uploadedimages.length} images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                :
                                <p className="loadingellipsis">Analyzing</p>
                            }

                        </label>
                        {/* <label>
                            <h4>Features Detection</h4>
                            <p>Ok! (50 images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                        </label> */}
                        <label>
                            <h4>Image Descriptions</h4>
                            {uploadedimages.length > 0 && analyzingroomtype != null && analyzingroomtype == false ?
                                <p>Ok! ({uploadedimages.length} images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                :
                                <p className="loadingellipsis">Analyzing</p>
                            }
                        </label>
                        <label>
                            <h4>Complaince</h4>
                            {compliancepassed == true ?
                                <p>Ok!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                : (compliancepassed == false ?
                                    <p>Failed <FontAwesomeIcon icon={faClose} className="mlscheck" style={{ color: 'red' }} /></p> : null)
                            }
                            {/* <p>Ok!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p> */}
                        </label>
                        <label>
                            <h4>Listing Descriptions</h4>
                            {listingdescriptionstatus == 1 ?
                                <p>Ok!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                : (listingdescriptionstatus == 2 ?
                                    <p>Failed <FontAwesomeIcon icon={faClose} className="mlscheck" style={{ color: 'red' }} /></p> : null)
                            }
                            {/* <p>Ok!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p> */}
                        </label>
                    </div>
                    <div className="col-10" id="imagesdiv">
                        <div className="row">
                            <div className="col-8">
                                <ul className="mlsright" style={{display:"none"}}>
                                    {uploadedimages.length > 0 ? uploadedimages.map((d) => (
                                        <li id={d.split('.').join('_')}>
                                            <img src={localimagebasepath + processid + "/" + d} />
                                            <h4>&nbsp;</h4>
                                            <p>&nbsp;</p>
                                        </li>
                                    )) : null
                                    }
                                </ul>
                                <ul className="mlsright">
                                    <li className="errorcomplaince">
                                        <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                        <h4>Front of Structure</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                                        <MyLoader />
                                        <span className="removeuploaded">
                                            <FontAwesomeIcon icon={faRemove}/>
                                        </span>
                                        <center><a href="javascript:;" className="common-save" style={{margin:"15px"}}>Upload</a></center>
                                    </li>
                                    <li>
                                        <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                        <h4>Front of Structure</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                        <MyLoader />
                                        <div className="rotating-text-wrapper-mls" style={{display:"none"}}>
                                            <div className="rotating-text-wrapper-mlsid" id="randomtext">  
                                                <h2>Checking Images for branding</h2>
                                                <h2>Checking images for sign posts</h2>
                                                <h2>Checking images for agent information</h2>
                                                <h2>Checking images for people</h2>
                                                <h2>Checking images for custom MLS rules</h2>
                                                <h2>Checking Images for branding</h2>
                                                <h2>Checking images for sign posts</h2>
                                            </div>
                                        </div>
                                        <span className="removeuploaded">
                                            <FontAwesomeIcon icon={faRemove}/>
                                        </span>
                                        <center><a href="javascript:;" className="common-save" style={{margin:"15px"}}>Upload</a></center>
                                    </li>
                                    <li>
                                        <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                        <h4>Front of Structure</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                        <MyLoader />
                                        <span className="removeuploaded">
                                            <FontAwesomeIcon icon={faRemove}/>
                                        </span>
                                        <center><a href="javascript:;" className="common-save" style={{margin:"15px"}}>Upload</a></center>
                                    </li>
                                    <li>
                                        <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                        <h4>Front of Structure</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                        <MyLoader />
                                        <span className="removeuploaded">
                                            <FontAwesomeIcon icon={faRemove}/>
                                        </span>
                                        <center><a href="javascript:;" className="common-save" style={{margin:"15px"}}>Upload</a></center>
                                    </li>
                                    <li>
                                        <img src="https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                        <h4>Front of Structure</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                        <MyLoader />
                                        <span className="removeuploaded">
                                            <FontAwesomeIcon icon={faRemove}/>
                                        </span>
                                        <center><a href="javascript:;" className="common-save" style={{margin:"15px"}}>Upload</a></center>
                                    </li>
                                    <li>
                                        <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600" />
                                        <h4>Front of Structure</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                        <MyLoader />
                                        <span className="removeuploaded">
                                            <FontAwesomeIcon icon={faRemove}/>
                                        </span>
                                        <center><a href="javascript:;" className="common-save" style={{margin:"15px"}}>Upload</a></center>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-4 mlsrightphoto">
                                <h5>Photo breakdown:</h5>
                                {/* <h5>Interior</h5> */}
                                <div className="row">
                                    <div className="col-12">
                                        <ul className="photobreak">
                                            {roomtypes.length > 0 ? roomtypes.map((d) => (
                                                <li>
                                                    <span>{d.name}</span>
                                                    <span>{d.count}</span>
                                                </li>
                                            )) : <li>
                                                <p className="loadingellipsis" style={{ fontSize: '14px' }}>Analyzing</p>
                                            </li>
                                            }
                                            {/* <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li> */}
                                        </ul>
                                    </div>
                                    {/* <div className="col-6">
                                        <ul className="photobreak">
                                            <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                                {/* <h5>Exterior</h5>
                                <div className="row">
                                    <div className="col-6">
                                        <ul className="photobreak">
                                            <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-6">
                                        <ul className="photobreak">
                                            <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12" id="divpropertyaddress">
                                <div className="row">
                                    <div className="col-9" style={{ position: "relative" }}>
                                        <label>
                                            Property address
                                        </label>
                                        {/* <input type="text" className="common-input"></input> */}
                                        {/* <SearchLocationInput onChange={() => null} /> */}
                                        <div className="search-location-input">
                                            <input id="txtPropAddress"
                                                ref={autoCompleteRef} className="common-input"
                                                onChange={event => setQuery(event.target.value)}
                                                placeholder="Enter your address"
                                                value={query}
                                            />
                                            <FontAwesomeIcon className="clearProp" onClick={() => clearPropAddress()} icon={faXmark} />
                                            <input id="hfLocationId" value={locationId} type="hidden"></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {compliancepassed == true ?
                            <>
                                <a href="javascript:;" className="common-save" style={{ marginTop: "20px" }} onClick={generatecontentfromdescription}>Save Photos & Continue</a>
                            </>
                            : null
                        }

                    </div>

                    <div className="col-10" id="compliancecheck">
                        <div className="row" style={{ marginTop: "50px" }}>
                            <div className="col-6">
                                <div className="wrap-progress">
                                    <h4>Checking images for branding</h4>
                                    <div className="progressload progress-striped">
                                        <div className="progress-bar">
                                        </div>
                                    </div>
                                    {/* <FontAwesomeIcon icon={faCheck} className="mlscheckone" /> */}
                                </div>
                                <div className="wrap-progress">
                                    <h4>Checking images for sign posts</h4>
                                    <div className="progressload progress-striped">
                                        <div className="progress-bar">
                                        </div>
                                    </div>
                                    {/* <FontAwesomeIcon icon={faCheck} className="mlscheckone" /> */}
                                </div>
                                <div className="wrap-progress">
                                    <h4>Checking images for watermarks</h4>
                                    <div className="progressload progress-striped">
                                        <div className="progress-bar">
                                        </div>
                                    </div>
                                    {/* <FontAwesomeIcon icon={faCheck} className="mlscheckone" /> */}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="wrap-progress">
                                    <h4>Checking images for agent info...</h4>
                                    <div className="progressload progress-striped">
                                        <div className="progress-bar">
                                        </div>
                                    </div>
                                    {/* <FontAwesomeIcon icon={faCheck} className="mlscheckone" /> */}
                                </div>
                                <div className="wrap-progress">
                                    <h4>Checking images for people...</h4>
                                    <div className="progressload progress-striped">
                                        <div className="progress-bar">
                                        </div>
                                    </div>
                                    {/* <FontAwesomeIcon icon={faCheck} className="mlscheckone" /> */}
                                </div>
                                <div className="wrap-progress">
                                    <h4>Checking images for custom MLS rules...</h4>
                                    <div className="progressload progress-striped">
                                        <div className="progress-bar">
                                        </div>
                                    </div>
                                    {/* <FontAwesomeIcon icon={faCheck} className="mlscheckone" /> */}
                                </div>
                            </div>
                            {compliancepassed == true ?
                                <div className="col-12">
                                    <div className="wrap-shield">
                                        <img src={shieldicon} className="shieldicon" />
                                        <h2>
                                            No Complaince <br /> Violations detected!
                                        </h2>
                                    </div>
                                </div> : (compliancepassed == false ?
                                    <div className="col-12">
                                        <div className="wrap-shield">
                                            <img src={shieldicon} className="shieldicon" />
                                            <h2>
                                                Complaince <br /> Violations detected!
                                            </h2>
                                        </div>
                                    </div> : null)
                            }
                        </div>
                    </div>
                    
                    <div className="col-10">
                        <div className="row">
                        <div className="col-12" id="divpropertydetails">
                                    <div className="row">
                                        <div className="col-12">
                                            <h4 className="prop-top-title">Property Details</h4>
                                        </div>
                                        <div className="col-12 mb-30">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label className="prop-lab-title">1. Property type</label>
                                                    {/* <Propertytype /> */}
                                                    {/* <Dropdown id="ddlPropertyType" onChange={() => setPropertyType()} options={optionspropertyType} placeholder="Select" /> */}
                                                    <input type="hidden" id="hfPropertyType"></input>
                                                    <select id="ddlPropertyType">
                                                        <option value="select">Select</option>
                                                        <option value="singlefamily">Single-family</option>
                                                        <option value="multifamily">Multi-family</option>
                                                        <option value="condo">Condo</option>
                                                        <option value="townhouse">Townhouse</option>
                                                        <option value="villa">Villa</option>
                                                        <option value="apartment">Apartment</option>
                                                        <option value="residential">Residential</option>
                                                        <option value="land">Land</option>
                                                        <option value="commercial">Commercial</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 mb-30">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label className="prop-lab-title">2. Property attributes</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Number of bedrooms<span style={{color:"red"}}><b>*</b></span></label>
                                                    {/* <Dropdown id="ddlBedrooms" options={optionsBedrroms} placeholder="Select" /> */}
                                                    <select id="ddlBedrooms">
                                                        <option value="select">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                        <option value="7">7</option>
                                                        <option value="8">8</option>
                                                        <option value="9">9</option>
                                                        <option value="10">10</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Number of bathrooms<span style={{color:"red"}}><b>*</b></span></label>
                                                    {/* <Dropdown id="ddlBathrooms" options={optionsBathroms} placeholder="Select" /> */}
                                                    <select id="ddlBathrooms">
                                                        <option value="select">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="1.5">1.5</option>
                                                        <option value="2">2</option>
                                                        <option value="2.5">2.5</option>
                                                        <option value="3">3</option>
                                                        <option value="3.5">3.5</option>
                                                        <option value="4">4</option>
                                                        <option value="4.5">4.5</option>
                                                        <option value="5">5</option>
                                                        <option value="5.5">5.5</option>
                                                        <option value="6">6</option>
                                                        <option value="6.5">6.5</option>
                                                        <option value="7">7</option>
                                                        <option value="7.5">7.5</option>
                                                        <option value="8">8</option>
                                                        <option value="8.5">8.5</option>
                                                        <option value="9">9</option>
                                                        <option value="9.5">9.5</option>
                                                        <option value="10">10</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Floors<span style={{color:"red"}}><b>*</b></span></label>
                                                    {/* <Dropdown id="ddlFloors" options={optionsFloors} placeholder="Select" /> */}
                                                     <select id="ddlFloors">
                                                        <option value="select">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Floor Area(sqft)<span style={{color:"red"}}><b>*</b></span></label>
                                                    <input id="txtArea" type="text" className="common-input" />
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Garage type</label>
                                                    <select id="ddlGaragetype">
                                                    <option value="select">Select</option>
                                                        <option value="attached">attached</option>
                                                        <option value="detached">detached</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Garage spaces</label>
                                                    {/* <Dropdown id="ddlGaragespaces" options={optionsGarage} placeholder="No of cars" /> */}
                                                    <select id="ddlGaragespaces">
                                                        <option value="select">Select</option>
                                                        <option value="1">1 car</option>
                                                        <option value="2">2 cars</option>
                                                        <option value="3">3 cars</option>
                                                        <option value="4">4 cars</option>
                                                        <option value="5">5 cars</option>
                                                        <option value="6">6 cars</option>
                                                        <option value="7">7 cars</option>
                                                        <option value="8">8 cars</option>
                                                        <option value="9">9 cars</option>
                                                        <option value="10">10 cars</option>
                                                    </select>
                                                </div>                                                
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <center><a href="javascript:;"  style={{margin:"15px 0 25px"}} className="common-save">Next</a></center>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className="col-10" id="editordiv">
                        <div className="row">
                            <div className="col-12 text-end chech-right" style={{ marginBottom: "10px" }}>
                                {/* <span><FontAwesomeIcon icon={faCopy} onClick={this.copyToClipboard} style={{marginLeft:'0px'}} /></span> */}
                                {copySacpeAvailable == true ?
                                    <span onClick={Checkplagiarism} tooltip="Check plagiarism" flow="left">
                                        <FontAwesomeIcon icon={faShield} style={{ fontSize: '24px', cursor: "pointer", color: '#9333ea' }} />
                                    </span> : null}
                                <span
                                    id="plagiarisminfo"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    className="text-count"
                                    style={{
                                        backgroundColor: "#f44336",
                                        color: "#fff",
                                        display: "none",
                                    }}
                                >
                                    5 copies found
                                </span>
                                {/* <span className="text-count">5 words</span> */}
                            </div>
                        </div>
                        <div className="row">
                            {/* {generatedcontent !=null && generatedcontent !="" ? generatedcontent.map((d) => (  */}
                            <div className="col-12">

                                <div id="divOuterContent" className="output-wrap slider">
                                    <span className="float-end" id="spanCharCount" style={{ fontSize: "13px", display: "block" }}>Character Count: <b id="lblCcount">125</b></span>
                                    {(grammarlyKeyData != "" ?
                                        <GrammarlyEditorPlugin clientId={Cookies.get('g_key')}>
                                            <div id="divGeneratedContent" style={{ minHeight: "55vh" }} className='out-content market-scroll'>

                                            </div>
                                        </GrammarlyEditorPlugin>
                                        :
                                        <div id="divGeneratedContent" style={{ minHeight: "55vh" }} className='out-content market-scroll'>

                                        </div>
                                    )}
                                    <div id="divOutputIcons" style={{ display: "none", position: "relative", paddingBottom: "50px", zIndex: "39999" }} className="out-icons">
                                        <span className="float-end">
                                            <a href="javascript:;" onClick={() => copyToClipboard()} className="common-border-btn">Copy</a>
                                            <a href="javascript:;" id="hrefEditContent" onClick={() => copyToClipboardEdit()} className="common-border-btn">Edit</a>
                                            {/* <a href="javascript:;" id="hrefEditContent" onClick={()=>Highlightkeys('dropped or false ceiling, flooring parquet')} className="common-border-btn">replace</a> */}
                                            <a href="javascript:;" onClick={() => generateaicontent()} className="common-border-btn">Rewrite</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {/* )) : null }   */}
                        </div>
                    </div>
                    {/* <div className="col-10">
                        <div className="row">
                            <div className="col-6">
                                <h2 className="titlelist-desc">Listing Description</h2>
                            </div>
                            <div className="col-6">
                                <div className="wrap-list-desc">
                                    <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600"></img>
                                    <h4>123 Main St.</h4>
                                </div>
                            </div>
                            <div className="col-12" style={{marginTop:"50px"}}>
                                <div className="row">
                                    <div className="col-9">
                                        <div className="scrolldescpara">
                                            <p>Discover Single-Level Living in Whitefish River Ranch. Welcome to your dream home! </p><p>This single-level residence offers a perfect blend of elegance and comfort. With 4 bedrooms, 2 baths, and a generous 2,450 square feet of living space on one acre. </p><p>Bathed in natural light, the southern-facing windows grace the living room with an abundance of natural light, creating an inviting ambiance from dawn to dusk. And for those cozy evenings, a dual-sided fireplace effortlessly connects the living room to a chef's kitchen and dining room, providing a warm and welcoming setting for gatherings, entertaining, or simply unwinding in style.</p><p>The primary bedroom is a sanctuary in itself. With an ensuite bathroom featuring a soothing soaking tub, it's the perfect place to unwind, relax, and escape from the day's stresses. This is your personal oasis, right within your home. Step outside, and you'll be greeted by a meticulously manicured and landscaped large backyard. </p><p>It's a slice of paradise, fully fenced for privacy, with a garden that's ideal for green thumbs, and breathtaking unobstructed southern views that create a backdrop for unforgettable moments. It's the ultimate spot for backyard gatherings, BBQs, and the creation of cherished family memories.</p><p> Extraordinary Amenities: This home is not just about the indoors. An attached double car garage ensures convenience, while an additional detached 2-car garage/shop offers endless possibilities. Plus, there's an unfinished bonus room above the detached garage/shop, ready to be transformed into the space of your dreams. </p><p>Convenient Serenity: Whitefish River Ranch provides the best of both worlds. Conveniently located to access all the attractions and amenities that the Flathead Valley has to offer, Glacier National Park, Flathead Lake, Big Mountain Skiing, are less than an hour away, yet it remains a peaceful and quiet escape from the hustle and bustle. </p><p>Don't miss this opportunity to make this exceptional property your own. NEW ADDITIONAL PHOTOGRAPHS PLANNED for WEEK of October 30. For more information or to schedule a viewing, contact Steve Wray at 406-407-4744 or reach out to your real estate professional.</p>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <h4 className="descailisttitle">Choose an AI generated descripton</h4>
                                        <ul className="descailist">
                                            <li className="active">
                                                <FontAwesomeIcon icon={faStar} />
                                                <h4>Standard</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faList} />
                                                <h4>Descriptive</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faSmileBeam} />
                                                <h4>Playful</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faUserTie} />
                                                <h4>Professional</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faCheckSquare} />
                                                <h4>Simplified</h4>
                                            </li>
                                        </ul>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div> */}



                    {/* {listingdescriptionstatus == 1 ?
                    <div className="col-10">
                        <div className="publishlist">
                            <img src={shieldicon} className="shieldicon"/>
                            <h2>All done!</h2>
                            <h4>Are you ready to publish?</h4>
                            <a href="javascript:;" className="common-save" style={{ marginTop: "20px" }} onClick={comingsoon}>Publish Listing</a>
                        </div>
                    </div>
                    : null} */}
                </div>
            </div>
        </div>
    )
    // }
};

export default Mls;